export const createAudioManager = () => {
    if (typeof window === 'undefined') return null
    
    const ctx = new AudioContext()
    const buffers = new Map<string, AudioBuffer>()
    const gainNodes = {
        music: ctx.createGain(),
        sfx: ctx.createGain(),
        narration: ctx.createGain(),
    }
    Object.values(gainNodes).forEach((g) => g.connect(ctx.destination))

    const resume = () => ctx.resume()
    const suspend = () => ctx.suspend()

    const load = async (url: string) => {
        if (buffers.has(url)) return

        try {
            const res = await fetch(url, { mode: 'cors' })
            if (!res.ok) {
                throw new Error(`Failed to load ${url}: ${res.status} ${res.statusText}`)
            }
            
            const buf = await res.arrayBuffer()
            const decoded = await ctx.decodeAudioData(buf)
            buffers.set(url, decoded)
        }
        catch (err) {
            console.error(`Audio load error for "${url}":`, err)
        }
    }

    const play = (
        url: string,
        type: keyof typeof gainNodes = 'sfx',
        loop = false
    ) => {
        const buffer = buffers.get(url)
        if (!buffer) return
        const src = ctx.createBufferSource()
        src.buffer = buffer
        src.loop = loop
        src.connect(gainNodes[type])
        src.start()
    }

    const setVolume = (type: keyof typeof gainNodes, value: number) => {
        // console.log('set', type, value)
        gainNodes[type].gain.value = value
    }

    const handleVisibilityChange = () => {
        if (document.hidden) {
            suspend()
        } else {
            setTimeout(() => {
                resume()
            }, 500)
        }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return { load, play, setVolume, resume }
}
  